const es = {
	"401": {
		"oops": "¡Vaya!",
		"noAuth": "Sin permiso para esta página",
		"goback": "Atrás",
		"gohome": "Inicio"
	},
	"404": {
		"notFound": "Página no encontrada"
	},
	"version": {
		"to_old": "Versión antigua",
		"to_new": "Nueva versión",
		"default_node": "Nodo por defecto",
		"default_theme": "Tema por defecto",
		// "node_err": "用户不存在，切换节点失败",
		"custom_theme": "Tema personalizado"
	},
	"intro": {
		"sys_msg": "Mensaje del sistema",
		"gaa_msg": "Notificación de alerta",
		"new_guide": "Guía",
		"slider_quite": "Salir",
		"slider_pre": "Anterior",
		"slider_next": "Siguiente",
		"slider_enter": "Nueva versión",
		"step_project_1": "Gestión de dispositivos",
		"step_project_2": "Nuevo",
		"step_project_3": "Gestión de proyectos",
		"step_project_4": "Dispositivos por proyecto. Puede",
		"step_project_5": "crear, editar, eliminar",
		"step_mode_1": "Elija estilo de lista",
		"step_mode_2": "La lista puede mostrarse en",
		"step_mode_3": "lista o tarjetas",
		"step_mode_4": "según su preferencia.",
		"step_device_1": "Encuentre dispositivos rápido",
		"step_device_2": "Nueva función",
		"step_device_3": "Seguir dispositivo",
		"step_device_4": ", ",
		"step_device_5": "Pase el cursor",
		"step_device_6": "sobre el dispositivo y siga,",
		"step_device_7": "Los seguidos",
		"step_device_8": "se mostrarán como",
		"step_device_9": "fijados",
		"step_device_10": "para acceso rápido.",
		"step_operate_1": "Disposición más clara",
		"step_operate_2": "Vea flujo de energía, info, gráficos, análisis y alertas del dispositivo."
	},
	"plantCode": {
		"codeApplication": "Solicitar código",
		"haveDevice": "Si tiene dispositivo, regístrese",
		"goRegister": "Registrarse",
		"useDemo": "¿Sin código? Solo para demo",
		"applyNow": "Solicitar ahora",
		"code_is_required": "Código obligatorio",
		"pleaseCode": "Ingrese el código",
		"pleaseName": "Ingrese su nombre",
		"PleaseCompanyName": "Nombre de empresa",
		"PleaseCompanyAddress": "Dirección de empresa",
		"PleaseNumber": "Ingrese su teléfono",
		"PleaseEmail": "Ingrese su email",
		"PleaseApplication": "Describa el motivo",
		"reasonNotEmpty": "Motivo obligatorio",
		"successfulApplication": "Enviado. Le responderemos pronto."
	},
	"retrieveUser": {
		"forgetUser": "Olvidó cuenta",
		"illustrate": "Ingrese PN de cualquier dispositivo para recuperar su cuenta.",
		"pn": "Ingrese PN del dispositivo",
		"comfig": "Confirmar",
		"Return_to_login": "Volver al login",
		"accountInfo": "Info de cuenta",
		"user": "Su usuario es",
		"phone": "Teléfono vinculado:",
		"email": "Email vinculado:",
		"pleasePn": "Ingrese PN",
		"pnError": "PN incorrecto",
		"pnErrorMsg": "Datalogger no encontrado"
	},
	"login": {
		"login": "Iniciar sesión",
		"loginSuc": "Sesión iniciada",
		"no_account_yet": "¿Sin cuenta?",
		"remember_pwd": "Recordar contraseña",
		"no_invitation": "¿Sin código? Contáctenos",
		"linkman": "Yibang Solar",
		"signup": "Registrarse",
		"usr": "Usuario",
		"pwd": "Contraseña",
		"sample_station": "Demo",
		"invitation": "Código demo",
		"invitationLogin": "Inicio de sesión con código de experiencia",
		"forgotPwd": "¿Olvidó su contraseña?",
		"forgotUser": "Olvidó su cuenta",
		"usrformat": "Formato de cuenta (2<=longitud de usuario<=32)",
		"pwdformat": "Formato de contraseña (6<=longitud de contraseña<=32)",
		"YHLogin": "Inicio de sesión de usuario",
		"YZcode": "Por favor ingrese el código de verificación",
		"code": "Deslice el control deslizante para completar el rompecabezas",
		"Swipe_right": "Deslice hacia la derecha",
		"scan_login": "Inicio de sesión con escaneo",
		"open": "Abrir",
		"Scancode_login": "Inicio de sesión con escaneo QR",
		"scanning": "Escaneando",
		"success": "Éxito",
		"Pleaseconfirm_login": "Por favor confirme el inicio de sesión",
		"SmartESS": "SmartESS",
		"pv123": "PV123 ESS",
		"X_Tech": "X-Tech",
		"app_download": "Descarga de APP",
		"scan_download": "Escanee con su teléfono para descargar la APP",
		"YZcode_format": "Formato de código de verificación incorrecto, por favor ingrese números",
		"no_validitycode": "El código de invitación no está dentro del período de validez",
		"auto_login": "Inicio de sesión automático",

	},
	"signup": {
		"login": "Iniciar sesión",
		"code": "Código 6 dígitos",
		"pwd": "6-32 caracteres (números, letras, guiones bajos), distingue mayúsculas/minúsculas",
		"confirm_password": "Confirmar contraseña",
		"phone": "Teléfono",
		"phone_form": "Máx 32 caracteres",
		"pn": "14 o 18 caracteres",
		"usr": "2-32 caracteres (letras, números, _)",
		"email": "Email",
		"email_form": "Máx 64 caracteres",
		"existing_account": "¿Ya tiene cuenta?",
		"Register_account": "Registrar cuenta",
		"signup": "Registrar",
		"emailSignup": "Registro por email",
		"phoneSignup": "Registro por teléfono",
		"registered": "Registrado",
		"success": "Registro exitoso",
		"mobileformat": "Teléfono inválido (6-32)",
		"mobileformat1": "Ingrese teléfono válido",
		"emailformat": "Ingrese email válido",
		"usrformat": "Formato de cuenta incorrecto, 2-32 caracteres (solo se permiten chino, letras, números y guiones bajos)",
		"pwdformat": "Formato de contraseña incorrecto, 6-32 caracteres (solo se permiten números, letras y guiones bajos)",
		"pnformat": "Formato de PN incorrecto, 14 o 18 dígitos (solo se permiten números y letras)",
		"qiang": "Fuerte",
		"zhong": "Media",
		"di": "Débil",
		"qiangdu": "Seguridad:",
		"Byte_1": "Ingresados",
		"Byte_2": "caracteres",
		"usr_pl": "Usuario",
		"pwd_pl": "Contraseña",
		"confirm_pl": "Confirmar contraseña",
		"confirm_Pwdpl": "Confirmar",
		"email_pl": "Email",
		"mobile_pl": "Teléfono",
		"code_pl": "Código",
		"PN_pl": "PN",
		"too_simple": "Contraseña muy simple",
		"country_pl": "País o región",
	},
	"createPlant": {
		"imageLimit": "Solo jpg,png, máx 8M",
		"fileExceed": "Archivo muy grande",
		"uploadSuccess": "Subido",
		"basic_settings": "Config básica",
		"Standard_setting": "Config estándar",
		"System_settings": "Config sistema",
		"Solar_settings": "Config solar",
		"Grid_settings": "Config red",
		"Battery_settings": "Config batería",
		"Battery_settingsTT": "Config batería general",
		"Battery_settings1": "Batería 1",
		"Battery_settings2": "Batería 2",
		"Work_settings2": "Estado trabajo sistema",
		"Machine_settings2": "Modo espera máquina",
		"Clear_settings2": "Borrar fallos",
		"Control_settings": "Config almacenador",
		"Load_setting": "Config carga",
		"other_settings": "Otros",
		"Basic_setting": "Básico",
		"Advanced_setting": "Avanzado",
		"select_all": "Todo",
		"pv": "FV",
		"gd": "Red",
		"bt": "Batería",
		"bc": "Carga",
		"sy": "Sistema",
		"eg": "Generador",
		"hl": "Carga hogar",
	},
	"Upload": {
		"Upload": "Subir"
	},
	"menu": {
		"home": "Inicio",
		"datalogger": "Datalogger",
		"account": "Cuentas",
		"device": "Dispositivos",
		"overview": "Resumen",
		"alarm": "Alertas",
		"setting": "Config sistema",
		"personal": "Info personal",
		"basic": "Info básica",
		"password": "Cambiar contraseña",
		"alarmSetting": "Config alertas",
		"email": "Config email",
		"mobile": "Config móvil",
		"recharge": "Config recarga",
		"pay": "Recargar",
		"record": "Historial recargas",
		"rate": "Tarifas",
		"customize": "Personalizar",
		"firmware": "Gestión de actualización de firmware",
		"firmwarenew": "Gestión firmware",
		"adaptiveFirmware": "Firmware adaptativo",
		"intelligenceUpgrade": "Actualización inteligente",
		"intelligenceUpgradeTitle": "No hay paquete de actualización disponible, por favor contacte al fabricante",
		"intelligenceUpgradeTitle1": "¿Confirma que el dispositivo debe realizar una actualización inteligente?",
		"intelligenceUpgradeTitle2": "No se encontró ningún paquete de actualización compatible",
		"Total_user": "Total usuarios:",
		"myDevice": "Mis dispositivos",
		"strategy": "Estrategia de actualización local",
		"cloudsUpgrade": "Actualización nube",
		"functionalApplication": "Aplicaciones",
		"browseAccount": "Subcuentas",
		"log": "Log datalogger",
		"actionLog": "Log operaciones",
		"Manufacturer": "Fabricantes",
		"datalogger_list": "Lista datalogger",
		"manufacturer_account": "Cuenta fabricante",
		"manufacturer_code": "Código fabricante",
		"protocol_binding": "Binding protocolo",
		"type_code": "Código tipo",
		"protocol_change": "Cambiar protocolo",
		"AIP_Interface": "Interfaz API",
		"protocol_operation": "Herramienta protocolo",
		"recharge_management": "Gestión recargas",
		"device_management": "Gestión dispositivos",
		"KEY_List": "Lista KEY",
		"Protocol_instruction": "Instrucciones protocolo",
		"Raw_data": "Datos raw",
		"Recharge_remedy": "Corregir recarga",
		"device_function": "Funciones dispositivo",
		"Password_maintenance": "Mant. contraseña",
	},
	"header": {
		"plant_owner": "Propietario",
		"personal_infor": "Info personal",
		"change_password": "Cambiar contraseña",
		"bind_mobile": "Vincular móvil",
		"bind_email": "Vincular email",
		"language": "Idioma",
		"log_out": "Salir",
		"skin": "Tema",
		"shopping_mall": "Tienda",
		"operating_manual": "Manual",
		"pleaseSelect": "Seleccione",
		"pleaseSelect1": "Seleccione fecha",
		"pnAndAlias": "PN / Nombre datalogger",
		"pnAndSN": "PN / SN"
	},
	"role": {
		"plantOwnerNew": "Usuario",
		"plantOwner": "Propietario",
		"manufacturer": "Fabricante",
		"distributor": "Distribuidor",
		"group": "Grupo",
		"viewer": "Visualizador",
		"all": "Todos"
	},
	"statistic": {
		"All": "Todos",
		"regiontotal": "Total regiones",
		"deviceStatus": "Estado dispositivo",
		"regionPercent": "% región",
		"userActivity": "Actividad usuarios",
		"dataUpdateTime": "Hora de actualización de datos",
		"normal": "Normal",
		"offline": "Offline",
		"Allstate": "Todos estados",
		"warning": "Advertencia",
		"fault": "Fallo",
		"standby": "Standby",
		"totalDevice": "Todos dispositivos",
		"allDevice": "Total dispositivos",
		"totalRegion": "Todas regiones",
		"other": "Otros",
		"allAccount": "Todos usuarios",
		"generalAccount": "Propietarios",
		"adminAccount": "Distribuidores",
		"active": "Activo",
		"inactive": "Inactivo",
		"pv": "Datos FV",
		"gd": "Datos red",
		"sy": "Datos dispositivo",
		"bt": "Datos batería",
		"bc": "Datos carga"
	},
	"account": {
		"title_pwd": "Contraseña incorrecta",
		"title_pwd1": "Contraseña: 6-32 caracteres",
		"title_pwd2": "Confirme nueva contraseña",
		"title_mobile": "Ingrese móvil de 11 dígitos",
		"title_edit": "Ingrese info a editar",
		"title_info": "Email inválido",
		"title_info1": "Móvil inválido",
		"allAccount": "Todos usuarios",
		"userAccount": "Usuario",
		"groupAccount": "Grupo",
		"uselists": "Lista usuarios",
		"accountManage": "Gestión cuentas",
		"groupManage": "Gestión grupos",
		"activeStatus": "Actividad",
		"accountGroup": "Grupo usuario",
		"createAccount": "Crear cuenta",
		"relatedOwner": "Asociar propietario",
		"relatedSuccess": "Asociado",
		"adminRelated": "Seleccione admin",
		"role": "Tipo usuario",
		"role1": "Tipo:",
		"selectUserType": "Seleccione tipo",
		"generalAccount": "Cuenta normal",
		"manageAccount": "Cuenta admin",
		"accountName": "Usuario",
		"accountName1": "Usuario:",
		"accountName2": "Ingrese usuario",
		"accountRole": "Rol",
		"nickname": "Apodo",
		"nickname1": "Apodo:",
		"password": "Contraseña",
		"password1": "Contraseña:",
		"newPwd": "Nueva contraseña",
		"newPwd1": "Nueva:",
		"confirmpassword": "Confirmar",
		"confirmpassword1": "Confirmar:",
		"createTime": "Creación",
		"accountStatus": "Estado",
		"dataloggerNum": "Dataloggers",
		"deviceNum": "Dispositivos",
		"projectNum": "Proyectos",
		"lastLogin": "Último login",
		"editUser": "Editar usuario",
		"editAccount": "Editar cuenta",
		"group": "Grupo",
		"group1": "Grupo:",
		"groupto": "Mover a",
		"changeGroup": "Mover a grupo:",
		"chooseGroup": "Seleccione grupo",
		"changeGroupSuc": "Movido",
		"defaultGroup": "Grupo por defecto",
		"enable": "Activar",
		"disable": "Desactivar",
		"confirmDisable": "¿Desactivar usuario?",
		"afterDisable": "No podrá iniciar sesión ni modificar contenido",
		"disableSuc": "Desactivado",
		"confirmEnable": "¿Activar usuario?",
		"deleteUser": "Eliminar cuenta",
		"afterEnable": "Podrá iniciar sesión y modificar contenido",
		"confirmDelete": "¿Eliminar?",
		"notRecovered": "No se puede recuperar...",
		"deleteSuc": "Eliminado",
		"resetPwd": "Resetear contraseña",
		"allTypeUser": "Todos tipos",
		"powerStationOwner": "Propietario",
		"powerStationViewer": "Visualizador",
		"admin": "Admin",
		"riyueyuan_lineSonAdmin": "Subadmin línea",
		"riyueyuan_SonAdmin": "Subadmin",
		"nodata": "Sin datos",
		"reason": "Sin gráfico, posibles causas:",
		"reason1": "Dispositivo sin datos",
		"reason2": "Protocolo sin campos de energía",
		"reason3": "Protocolo sin campos de potencia",
		"createSuc": "Cuenta creada",
		"resetPwdSuc": "Contraseña reseteada",
		"allGroup": "Todos grupos",
		"unclassified": "Sin clasificar",
		"cannotRedirect": "No es cuenta ESS",
		"newPwdEmpty": "Nueva contraseña vacía",
		"accountList": "Lista cuentas",
		"mobile": "Móvil",
		"mobile1": "Móvil:",
		"email": "Email",
		"email1": "Email:",
		"modifiedsuccess": "Info modificada!",
		"enablesuccess": "Activado!",
		"disablesuccess": "Desactivado!",
		"groupsuccess": "Agrupado!",
		"pwdresetsuccess": "Contraseña reseteada!",
		"Deletesuccessfully": "Cuenta eliminada!",
		"plantOwner": "Propietario",
		"distributor": "Distribuidor",
		"operate": "Operación",
		"Edit": "Editar",
		"Delete": "Eliminar",
		"binding": "Vincular",
		"ascription": "Asignar",
		"ascriptionSuccess": "Asignado",
		"ascription_result": "Resultado",
		"cancel": "Cancelar",
		"finish": "Finalizar",
		"confirm": "Confirmar",
		"submit": "Enviar",
		"deletegroupsuccess": "Quitado del grupo!",
		"deletegroup": "Quitar del grupo",
		"currentTotal": "Total:",
		"projects": "proyectos",
		"searchPro": "Buscar proyecto",
		"devices": "dispositivos",
		"accounts": "usuarios",
		"placeholder": "Buscar usuario/móvil",
		"placeholder1": "Ingrese usuario/móvil",
		"lastLoginTs": "Último login",
		"enterHome": "Ir a inicio",
		"ownedDevices": "Dispositivos propios",
		"Distribution_collector": "Asignar datalogger",
		"tooltipContent": "Admin puede asignar dataloggers por pedido a distribuidores",
		"Distribution_method": "Método asignación",
		"Batch_allocation": "Lote",
		"Individual_allocation": "Individual",
		"Order_allocation": "Por pedido",
		"PNNum": "PN",
		"order_number": "Nº pedido",
		"Allocation_result": "Resultado",
		"Assigned_successfully": "Asignado",
		"order_check": "Verificar",
		"Confirm_assignment": "Confirmar asignar a",
		"IsIt": "?",
		"limitFormat": "Solo xlsx y xls",
		"Ple_orderNum": "Ingrese nº pedido",
		"Ple_orderNum1": "Nº pedido inválido",
		"Ple_orderNum2": "El pedido tiene",
		"Ple_orderNum3": "dataloggers, ¿asignar a",
		"err_orderNum": "Hay",
		"err_orderNum1": "dataloggers ya vinculados",
		"dataogger_swith": "¿Puede agregar datalogger?",
		"dataogger_swithTip": "¿Tiene permiso para agregar?",
		"account_number":"Cuenta",
		"Role_authority":"Permisos",
		"authority_Management":"Gestión permisos",
		"Related_roles":"Roles asociados",
		"Ple_role1":"Seleccione rol",
		"Ple_role2":"Nombre/ID rol",
		"Add_role":"Nuevo rol",
		"Edit_role":"Editar rol",
		"Role_id":"ID rol",
		"Role_name":"Nombre rol",
		"Ple_role3":"Ingrese nombre",
		"Role_des":"Descripción",
		"Ple_role4":"Ingrese descripción",
		"module":"Módulo",
		"First_page":"Página",
		"Secondary_page":"Subpágina",
		"Function_points":"Funciones",
		"Remove_role":"Eliminar rol",
		"Ple_role5":"Seleccione permisos",
		"No_permission_prompt":"Sin permiso, contacte admin",
		"Ple_role6":"Nombre rol ya existe",
		"limit_UserTypeNum":"Límite excedido",
		"limit_UserTypeDataPermission":"Distribuidor no puede tener rol con permisos datos",
		"edit_limit_UserTypeDataPermission":"Rol asociado a distribuidor",
		"dataPermission": "Permisos datos",
		"functionalPermission": "Permisos funciones",
	},
	"group": {
		"Create_groups": "Crear grupo",
		"Edit_groups": "Editar grupo",
		"Groups_list": "Lista grupos",
		"Group_name": "Nombre grupo",
		"Group_name1": "Nombre:",
		"userCount": "Usuarios en grupo",
		"note": "Nota",
		"note1": "Nota:",
		"Operate": "Operar",
		"Delete": "Eliminar",
		"cancel": "Cancelar",
		"finish": "Finalizar",
		"confirm": "Confirmar",
		"deletegroup": "Eliminar grupo",
		"deleteConfirm": "¿Eliminar grupo?",
		"entername": "Ingrese nombre",
		"deletesuc": "Grupo eliminado",
		"creatsuc": "Grupo creado",
		"editsuc": "Grupo editado"
	},
	"device": {
		"set": "Config",
		"ownerShip": "Cambio de propietario",
    "oldOwner": "Propietario anterior:",
    "nweOwner": "Nuevo propietario:",
    "loading": "Cargando...",
    "moreLoading": "Desplazar para cargar más",
		"pleaseDate": "Seleccione fecha",
		"noDate": "No fecha futura",
		"deviceDebug": "Depurar dispositivo",
		"upgradeType": "Tipo actualización:",
		"defaultUpgrade": "Por defecto",
		"cloudUpgrade": "Nube",
		"continueUpgrade": "Continuar",
		"continueUpgradeSuccess": "Agregado",
		"step": "Paso inicio:",
		"firmware_step_message": "Ingrese paso",
		"numberRlues": "Paso inválido",
		"firmware_package_message": "Seleccione firmware",
		"firmware_type_message": "Seleccione tipo",
		"baudrate_message": "Seleccione baudrate",
		"device_continueUpgrade": "Continuar actualización",
		"read": "Leer",
		"distribute": "Enviar",
		"optionTitle": "Seleccionados",
		"optionTitle1": "items",
		"optionTitle2": "Máx 4 parámetros",
		"optionTitle4": "Máx 12 parámetros",
		"optionTitle3": "No seleccione más de 2 opciones con unidades diferentes",
		"upBatchDeviceTip": "Actualización en lote: mismo firmware para múltiples dispositivos",
		"upSuccessDevice": "Exitosos",
		"upFailDevice": "Fallidos",
		"brandDevice": "Dispositivo",
		"brand0": "Otros almacenadores ESS",
		"brand1": "Inversor off-grid",
		"brand2": "Inversor",
		"brand3": "ESS integrado",
		"Allthemachines": "Todos",
		"deviceList": "Lista dispositivos",
		"device": "Dispositivo",
		"datalogger": "Datalogger",
		"dataloggerList": "Lista datalogger",
		"followList": "Seguidos",
		"proList": "Lista proyectos",
		"pro": "Proyecto",
		"deviceName": "Nombre",
		"dataview": "Parámetros tiempo real",
		"dataTips": "Dispositivo offline, sin datos.",
		"overview": "Resumen",
		"chart": "Gráficos",
		"analysis": "Análisis",
		"clause": "Detalles datos",
		"Current_data": "Datos actuales",
		"chosenParam": "Seleccionados",
		"optionalParam": "Opcionales",
		"reset": "Resetear",
		"energyFlow": "Flujo energía",
		"device_name": "Nombre dispositivo",
		"device_pn": "PN",
		"device_sn": "SN",
		"device_status": "Estado",
		"device_upgrade1": "Última actualización",
		"device_upgradeFirmware": "Seleccione firmware para actualizar",
		"device_upgradeTime": "Hora actualización",
		"device_upgradeName": "Nombre firmware",
		"device_upgradeStatus": "Estado",
		"device_upgradeProgress": "Progreso",
		"device_type": "Tipo",
		"device_code": "Protocolo",
		"device_code_form": "Protocolo:",
		"device_model": "Modelo",
		"User_belong": "Usuario",
		"field": "Control campo",
		"Datalogger_belong": "Datalogger",
		"detail": "Detalles",
		"pageSize": "Por página",
		"follow": "Seguir",
		"unfollow": "No seguir",
		"report": "Reporte",
		"timeSlot": "Período",
		"datalogger_pn": "PN datalogger",
		"coll_alias": "Alias datalogger",
		"device_address": "Dirección",
		"generation": "FV",
		"grid": "Red",
		"inverter": "Inversor",
		"battery": "Batería",
		"consumption": "Carga",
		"relay": "Microinversor",
		"alternator": "Generador",
		"familyLoad": "Carga familiar",
		"solar": "Solar",
		"cur_today": "Hoy",
		"cur_thismonth": "Este mes",
		"cur_thisyear": "Este año",
		"cur_day": "Día",
		"cur_month": "Mes",
		"cur_year": "Año",
		"day": "Potencia",
		"month": "Energía mes",
		"year": "Energía año ",
		"all": "Total",
		"pvPower": "Potencia FV",
		"gridPower": "Potencia red",
		"batteryPower": "Potencia batería",
		"loadPower": "Potencia carga",
		"generated": "Generado",
		"charged": "Cargado",
		"discharged": "Descargado",
		"sold": "Vendido",
		"bought": "Comprado",
		"used": "Consumido",
		"normal": "Normal",
		"offline": "Offline",
		"warning": "Advertencia",
		"fault": "Fallo",
		"standby": "Standby",
		"universal_firmware": "Firmware universal",
		"communication_firmware": "Firmware comunicación",
		"control_firmware1": "Control 1",
		"control_firmware2": "Control 2",
		"control_firmware_bms": "BMS",
		"control_firmware_slavmcu": "SlavMCU",
		"default": "Por defecto",
		"modifySuc": "Modificado",
		"instruction_response": "Enviando, espere...",
		"debug_suc": "Depurado",
		"Debugfail": "Fallo, dispositivo offline",
		"Send_suc": "Comando enviado",
		"Send_Input": "Ingrese valor",
		"Send_fail": "Fallo envío",
		"fileExceed": "Archivo muy grande",
		"uploadSuccess": "Subido",
		"error1": "Solo .bin y .hex",
		"file_fist": "Seleccione firmware",
		"updatefail": "Fallo, datalogger puede estar offline",
		"update_suc": "Actualizado",
		"deleteSuc": "Eliminado",
		"Operation": "Operación",
		"edit": "Editar",
		"debug": "Depurar",
		"upgrade": "Actualización lote",
		"upgrade1": "Actualizar",
		"more": "Más",
		"one_click_read": "Leer todo",
		"cloudsUpgrade": "Actualización nube",
		"queryUpgrade": "Consultar progreso",
		"control": "Control",
		"delete": "Eliminar",
		"modify_alias": "Editar dispositivo",
		"serial_number": "SN:",
		"device_alias": "Nombre:",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"Device_sn": "SN dispositivo",
		"Device_pn": "PN:",
		"Instruction": "Instrucción:",
		"such_as": "Ej: AA BB CC DD EE FF",
		"return_content": "Respuesta:",
		"send": "Enviar",
		"clear_data": "Borrar datos",
		"clear_val": "Borrar",
		"copy_val": "Copiar",
		"copy_val_yes": "Copiado",
		"copy_val_no": "Fallo copia",
		"Field_Name": "Campo",
		"Unit": "Unidad",
		"current_val": "Valor actual",
		"Battery_voltage": "Voltaje batería",
		"Magnification": "Multiplicador",
		"Send_Command": "Enviar comando",
		"device_upgrade": "Actualizar firmware",
		"device_cloudsUpgrade": "Actualizar desde nube",
		"select_firmware": "Firmware:",
		"select_file": "Seleccione firmware",
		"firmware_type": "Tipo:",
		"select_type": "Seleccione tipo",
		"upgrade_brate": "Baudrate:",
		"select_brate": "Seleccione baudrate",
		"Upload": "Subir firmware",
		"Upload1": "Subir nuevo",
		"confirm_deldte": "¿Eliminar?",
		"deleteDevice": "Eliminar dispositivo",
		"Today_income": "Ingreso hoy",
		"Cumulative_income": "Ingreso total",
		"sellProfit_Today": "Venta hoy",
		"sellProfit_Total": "Venta total",
		"buyProfit_Today": "Compra hoy",
		"buyProfit_Total": "Compra total",
		"noAuth": "Sin usuario, sin permiso",
		"statistic": "Estadísticas",
		"protocolStatistic": "Estadísticas protocolo",
		"chooseProtocol": "Protocolo:",
		"parameter": "Parámetro",
		"value": "Valor",
		"Upgrading": "Actualizando, espere",
		"System_Failed": "Fallo comunicación, actualización no iniciada",
		"Device_Offline": "Dispositivo o datalogger offline",
		"In_Upgrading": "Ya actualizando",
		"Update_Completed": "Actualizado",
		"Voltage": "Voltaje",
		"Electric": "Corriente",
		"power": "Potencia",
		"frequency": "Frecuencia",
		"Input_form": "Entrada",
		"add": "Agregar",
		"Output_table": "Salida",
		"Please_parameter": "Seleccione parámetro",
		"Successfully_modified": "Modificado",
		"edit_control": "Editar permisos control",
		"Equipment_agreement": "Protocolo",
		"Check_all": "Marcar todo",
		"Cancel_all": "Desmarcar todo",
		"administrator_cansee": "Marcado = visible para admin",
		"person_cansee": "Marcado = visible para propietario",
		"admin_authority": "Permisos admin",
		"person_authority": "Permisos propietario",
		"noDataPlease": "Sin datos, seleccione otro período",
		"Sn_deviceName": "SN/Nombre/PN/Usuario",
		"deviceInfo": "Info dispositivo",
		"alarmInfo": "Info alertas",
		"deviceNo": "Sin dispositivos",
		"showParam": "Mostrar parámetros",
		"selecParameters": "Parámetros seleccionados",
		"refresh": "Actualizar",
		"obtain": "Obtener",
		"moveResults": "Resultado movimiento",
		"moveSuc": "Movido",
		"maxSelect": "Máx 7 parámetros",
		"minSelect": "Mín 1 parámetro",
		"loadMore": "Cargar más ...",
		"upDevice": "Actualizar dispositivo",
		"addUpgrade": "Agregar tarea",
		"upgradeProgress": "Progreso actual",
		"deviceUpgradeProgress": "Progreso actualización",
		"addUpgradeSuccess": "Agregado",
		"domain":"Dominio",
		"create_ctrl_title":"Crear control",
		"edit_ctrl_title":"Editar control",
		"delete_domain":"Eliminar dominio",
		"delete_tips":"¿Eliminar control del dominio?",
		"hostname_required":"Dominio requerido",
		"device_rerolling":"Resincronizar",
		"device_synchronization":"Sincronizar",
		"update_first_data_time":"Modificar primer dato",
		"delete_device_chart_data":"Borrar datos gráfico",
		"delete_device_data":"Borrar detalles datos",
		"SN_required":"Ingrese SN",
		"device_code1":"Código dispositivo",
		"devcode_required":"Ingrese código",
		// "device_address":"通讯地址",
		"devaddr_required":"Ingrese dirección",
		"devaddr_again":"Confirme dirección",
		"PN":"PN datalogger",
		"SN":"SN dispositivo",
		"SN_again":"Confirme SN",
		"search_btn":"Buscar",
		"tips1":"Tip: Sincronizar puede corregir energía",
		"tips2":"Tip: Confirme SN y dirección",
		"tips3":"Tip: Datos eliminados no recuperables",
		"tips4_1":"Tip: Zona horaria:",
		"tips4_2":"Ajuste hora según zona horaria",
		"delete_tips_1":"¿Eliminar timestamp:",
		"delete_tips_2":"?",
		"sn_is_required": "SN requerido",
		"sdate_required":"Inicio requerido",
		"edate_required":"Fin requerido",
		"data_tips":"Parámetros incompletos",
		"match_tips":"SN o dirección no coinciden",
				"unbind_tips":"El dispositivo no está vinculado al propietario, vincule primero al propietario"
	},
	"alarm": {
		"device_Warning": "Advertencia",
		"device_Error": "Error",
		"device_Fault": "Fallo",
		"Alarm_Event": "Evento alerta",
		"Today_Alarm": "Alertas hoy",
		"Alarm_Type": "Tipo alerta",
		"Device_Type": "Tipo dispositivo",
		"Alarm_Status": "Estado",
		"Alarm_List": "Lista alertas",
		"deletes": "Eliminar",
		"tips": "Tip",
		"details": "Detalles",
		"alarmDetails": "Detalle alerta",
		"alarmInfo": "Info alerta",
		"alarmDevice": "Info dispositivo",
		"delete_alarm": "¿Eliminar alerta?",
		"Cancel": "Cancelar",
		"Confirm": "Confirmar",
		"Close": "Cerrar",
		"processed": "Procesado",
		"untreated": "Pendiente",
		"allAlarm": "Total alertas",
		"alarmStatus": "Estado alertas",
		"warningTitle": "Alertas 7 días",
		"faultTitle": "Fallos 7 días",
		"alarmNum": "Nº alertas",
		"faultNum": "Nº fallos",
		"all": "Todos",
		"warning": "Advertencia",
		"error": "Error",
		"fault": "Fallo",
		"offline": "Offline",
		"inverter": "Inversor",
		"monitor": "Monitor ambiental",
		"smart_meters": "Medidor inteligente",
		"combining_manifolds": "Caja combinadora",
		"Camera": "Cámara",
		"Battery": "Batería",
		"Charger": "Cargador",
		"storage": "Almacenador",
		"Prevent_arcing_island": "Anti-isla",
		"Microinverter": "Microinversor",
		"Occurrence_time": "Hora inicio",
		"endtime": "Hora fin",
		"Device_Name": "Nombre",
		"Device_PN": "PN datalogger",
		"Plant": "Planta",
		"Alarm_Code": "Código",
		"Alarm_Describe": "Descripción",
		"Device_SN": "SN dispositivo",
		"device_alias": "Alias",
		"device_address": "Dirección",
		"User": "Usuario",
		"Status": "Estado",
		"Operation": "Operación",
		"Delete_selected": "Eliminar selección",
		"deleted_successfully": "Alerta eliminada!",
		"Alarm_Msg": "Nuevo mensaje",
		"Intro_Msg": "Guía",
		"Alarm_Read": "Todas las alertas leídas",
		"Alarm_data": "Sin mensajes nuevos!",
		"Alarm_Message": "Su",
		"Alarm_Message1": "tiene",
		"curSelected": "Seleccionados",
		"_Data": "items",
		"more": "Más",
		"ruleManage": "Gestión filtros alerta",
		"ruleNew": "Nueva regla",
		"ruleName": "Nombre regla",
		"timeSlot": "Período",
		"deviceType": "Tipo dispositivo",
		"deviceFilter": "Filtrar dispositivo",
		"alrmType": "Filtrar tipo",
		"alrmDes": "Filtrar descripción",
		"filterHistory": "Historial filtros",
		"clearHistory": "Limpiar historial",
		"view": "Ver",
		"back": "Volver",
		"exportArchive": "Exportar alarma archivada",
		"archiveRecord": "Archivo",
		"archiveTip": "La lista incluye todas las alarmas no procesadas y los registros procesados en 7 días"
	},
	"datalogger": {
		"activeStatus": "Estado activación",
		"Active": "Activado",
		"notActive": "No activado",
		"timeZone": "Zona horaria",
		"please_title": "Ingrese 'YES' para resetear",
		"frequency": "Frecuencia",
		"heartbeat": "Heartbeat",
		"warehousing_time": "Fecha almacén",
		"start_address": "Dirección inicio",
		"deadline_address": "Dirección fin",
		"title_usr": "Sin usuario asignado",
		"datalogger_log": "Log",
		"min_addr": "Dir. mínima",
		"max_addr": "Dir. máxima",
		"transmission": "Modo transparente",
		"transparent_set": "Protocolos transparentes",
		"devcode": "Código fabricante",
		// "protocol_code": "协议厂家编码",
		"domain_name": "Dominio",
		"transmission1": "Modo local",
		"transmission2": "Modo transparente",
		"noDate": "Seleccione dentro de 3 días",
		"paramSetting": "Config parámetros",
		"paramName": "Nombre",
		"paramPar": "ID parámetro",
		"paramVal": "Valor",
		"dataloggerView": "Detalles datalogger",
		"describe": "Descripción",
		"field_name": "Campo",
		"checkVal": "Valor",
		"resetTitle1": "¿Resetear datalogger? (1: Permitir re-registro, 2: Limpiar dispositivos asociados, 3: Eliminar todos los datos)",
		"unbingTitle": "¿Desvincular datalogger? (1: Eliminar admin distribuidor asociado; 2: Re-vincular requiere que el distribuidor lo agregue)",
		"getTitle": "Obtener parámetro",
		"postTitle": "Configurar",
		"debugeTitle": "Depurar",
		"getName": "Obtener (decimal)",
		"postName": "ID (decimal)",
		"debugeName": "Comando:",
		"getVal": "Valor actual:",
		"postVal": "Nuevo valor:",
		"debugeVal": "Resultado:",
		"debugeAddr": "Dirección:",
		"getSucc": "Obtenido",
		"postSucc": "Configurado",
		"debugeSucc": "Enviado",
		"copyVal": "Copiar",
		"huoqu": "Obtener",
		"shezhi": "Configurar",
		"xiafa": "Enviar",
		// "timing": "令 时",
		// "winterTime": "冬令时",
		// "daylightTiming": "夏令时",
		"copy": "Copiado",
		"flowCard": "Tarjeta no válida",
		"province": "Provincia/Estado",
		"city": "Ciudad",
		"county": "Condado",
		"country": "País",
		"Flowcard_status": "Estado tarjeta",
		"GPRS_traffic": "Tráfico GPRS",
		"upBatchDataloggerTip": "Actualización en lote: mismo firmware para múltiples dataloggers",
		"upSuccessDatalogger": "Exitosos",
		"upFailDatalogger": "Fallidos",
		"Datalogger_Status": "Estado",
		"com_method": "Método comunicación",
		"Datalogger_PN": "PN",
		"Datalogger_List": "Lista",
		"Datalogger_Name": "Nombre",
		"Ple_PN": "Ingrese PN",
		"Ple_Alias": "Ingrese nombre",
		"Datalogger_type": "Tipo",
		"Datalogger_model": "Modelo",
		"Datalogger_method": "Comunicación",
		"Status": "Estado",
		"usr_belong": "Usuario",
		"administrator": "Admin",
		"Communication_balance": "Saldo",
		"load": "Dispositivos",
		"Firmware_Version": "Versión firmware",
		"signal": "Señal",
		"Operation": "Operación",
		"edit": "Editar",
		"reboot": "Reiniciar",
		"unbind": "Desvincular",
		"more": "Más",
		"resetData": "Resetear",
		"unbindUsr": "Desvincular propietario",
		"debug": "Depurar",
		"upgrade": "Actualizar",
		"delete": "Eliminar",
		"deleteTitle": "Eliminar datalogger",
		"reset": "Resetear",
		"resetCode": "Ingrese YES",
		"modify_datalog": "Modificar datalogger",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"datalogger_debug": "Depurar datalogger",
		"communication_address": "Dirección:",
		"Instruction": "Instrucción:",
		"such_as": "Ej: AA BB CC DD EE FF",
		"return_content": "Respuesta:",
		"send": "Enviar",
		"check": "Verificación",
		"InstructionType": "Formato de instrucción",
		"endMarker": "Marcador final",
		"noMarker": "Sin marcador final",
		"noCheck": "Sin verificación",
		"InstructionIssue": "Enviar instrucción",
		"Insufficient": "Cantidad insuficiente",
		"clear_data": "Borrar",
		"device_upgrade": "Actualizar firmware",
		"select_firmware": "Firmware:",
		"select_file": "Seleccione firmware",
		"Upload": "Subir",
		"prompt_message": "Mensaje",
		"confirm_deldte": "Al eliminar perderá acceso a todos los datos",
		"Normal": "Normal",
		"Offline": "Offline",
		"Online": "Online",
		"Normal1": "Estado online",
		"Offline1": "Estado offline",
		"Allstate": "Todos estados",
		"modifySuc": "Modificado",
		"resetSuc": "Reseteado",
		"unbindSuc": "Desvinculado",
		"devaddrfail": "Dirección vacía",
		"Debugfail": "Fallo, datalogger offline",
		"instruction_response": "Enviando, espere...",
		"fileExceed": "Archivo muy grande",
		"uploadSuccess": "Subido",
		"error1": "Solo .bin y .hex",
		"file_fist": "Seleccione firmware",
		"updatefail": "Fallo, datalogger puede estar offline",
		"update_suc": "Actualizado",
		"deleteSuc": "Eliminado",
		"debug_suc": "Depurado",
		"create": "Crear",
		"addSuc": "Datalogger agregado",
		"add": "Agregar dispositivo",
		"addScq": "Agregar datalogger",
		"batchAddScq": "Agregar en lote",
		"editDatalogger": "Modificar",
		"editDataloggerName": "Editar datalogger",
		"resetDataloggerName": "Resetear datalogger",
		"unbindDataloggerName": "Desvincular datalogger",
		"resetDataloggerExplain": "Resetea datos históricos. Operación irreversible!",
		"unbindDataloggerExplain": "Desvincula el propietario. El cliente debe revincular.",
		"rebootDataloggerName": "Reiniciar datalogger",
		"rebootDataloggerSuc": "Reiniciado",
		"fixOnRebootDataloggerName": "¿Reiniciar datalogger:",
		"fixOnRebootDataloggerName1": "?",
		"unbindTitle": "Ingrese 'YES' para desvincular del propietario",
		"resetTitle": "Ingrese 'YES' para resetear",
		"editSuc": "Datalogger modificado",
		"basic_info": "Info básica",
		"datalogger_pn": "PN:",
		"datalogger_name": "Nombre:",
		"nominalPower": "Potencia nominal",
		"install_date": "Fecha instalación",
		"installer": "Instalador",
		"location_info": "Ubicación",
		"location_info1": "Geo info",
		"district": "Distrito",
		"address": "Ubicación",
		"dataloggerAddress": "Dirección",
		"enterPosition": "Ingrese ubicación",
		"longi_lati": "Coordenadas",
		"latitude": "Latitud",
		"longitude": "Longitud",
		"currentAddress": "Dirección actual:",
		"timezone": "Zona horaria",
		"timezone1": "Zona horaria",
		"cp1": "Seleccione fecha instalación",
		"cp2": "Seleccione zona horaria",
		"cp3": "Ingrese potencia nominal",
		"cp4": "Seleccione moneda",
		"cp5": "Ingrese nombre",
		"cp6": "Seleccione proyecto",
		"cp7": "Seleccione coordenadas",
		"lonRange": "Longitud: -180 a 180",
		"latRange": "Latitud: -90 a 90",
		"cp9": "Ingrese dirección",
		"cp10": "Ingrese nombre proyecto",
		"income_info": "Info ingresos",
		"currency": "Moneda:",
		"buyProfit": "Precio compra:",
		"sellProfit": "Precio venta:",
		"unitProfit": "Precio consumo:",
		"generateProfit": "Precio generación:",
		"noNegative": "Ingrese número positivo",
		"buyProfitNew": "Precio compra",
		"sellProfitNew": "Precio venta",
		"generateProfitNew": "Precio generación",
		"add_datalogger": "Nuevo datalogger",
		"add_suc": "Agregado",
		"basicInfo": "Info básica",
		"connectionInfo": "Info conexión",
		"finishAdding": "Finalizar",
		"addResults": "Resultado",
		"addedSuccessfully": "Agregado",
		"finish": "Finalizar",
		"continueAdding": "Continuar",
		"nowNoAdd": "Más tarde",
		"reAdd": "Reintentar",
		"editResults": "Resultado edición",
		"resetResults": "Resultado reset",
		"unbindResults": "Resultado desvincular",
		"delResults": "Resultado eliminación",
		"locationTip": "Tip: Si la ubicación es incorrecta, ingrésela manualmente",
		"upDatalogger": "Actualizar datalogger",
		"type_code": "Código tipo",
		"type_name": "Nombre tipo",
		"new_type": "Nuevo tipo",
		"modification_type": "Modificar tipo",
		"delete_type": "Eliminar tipo",
		"prompt": "Eliminar código tipo",
		"prompt_codetip": "Código requerido",
		"prompt_desctip": "Nombre requerido",
		"input_prompt": "Código de 1 letra",
		"success_prompt": "Código creado!",
		"multi_binding": "Binding en lote",
		"search_PN": "Ingrese PN",
		"empty_prompt": "Sin datos, verifique PN",
		"bingding_status": "Estado binding",
		"unbound": "No vinculado",
		"bound": "Vinculado",
		"protocol_code": "Código protocolo",
		"protocol_name": "Nombre protocolo",
		"bind": "Vincular (modificar)",
		"bind_title": "Binding protocolo",
		"batch_bind_title": "Binding en lote",
		// "unbind": "解除绑定",
		"18digit": "Binding 18 dígitos",
		"18digit_title": "Binding 18 dígitos",
		"batch_protocol_binding": "Binding protocolo en lote",
		"upload_tips": "Tip: Formato xlsx/xls, ver imagen de referencia",
		"disabledText": "Obteniendo datos...",
		"disabledText1": "Seleccione protocolo",
		"upload_err": "Solo xlsx/xls",
		"bounding_success": "Protocolo vinculado!",
		"unbounding_success": "Protocolo desvinculado!",
		"unbound_tips": "¿Desvincular protocolo del datalogger",
		"unbound_tips1": "?",
		"batch_change": "Cambiar en lote",
		"batch_protocol_change": "Cambiar protocolo en lote",
		"dataloggerTipName": "Datalogger ya agregado por",
				"batch_edit_datalogger": "Editar datalogger en lote",
				"upload_column_tips": "Recordatorio: Columna A es PN del datalogger, Columna B es número de carga, Columna C es velocidad de baudios, Columna D es protocolo de comunicación, Columna E es código del fabricante del dispositivo, Columna F es código del fabricante del protocolo, Columna G es modo de recolección, Columna H es dirección mínima, Columna I es dirección máxima, sin título, consulte la siguiente imagen",
				"upload_csv_tips": "Recordatorio: El formato del archivo debe ser csv, consulte la siguiente imagen para el contenido",
				"click_enlarge": "Haga clic para ampliar detalles",
						"collector_expire_time": "Tiempo de expiración del recolector",
						"collection_cycle": "Ciclo de recolección",
								"ascii_display": "Visualización ASCII:"
	},
	"map": {
		"sn": "SN:",
		"datalogger": "Nombre:",
		"address": "Dirección:"
	},
	"rate": {
		"device_status": "Estado dispositivo",
		"datalogger_pn": "PN",
		"datalogger_pns": "PN:",
		"rate_list": "Lista tarifas",
		"datalogger_name": "Nombre",
		"status": "Estado",
		"Income_currency": "Moneda",
		"Income_currencys": "Moneda:",
		"generate_Rate": "Tarifa generación",
		"generate_Rates": "Tarifa generación:",
		"sell_Rate": "Tarifa venta",
		"sell_Rates": "Tarifa venta:",
		"buy_Rate": "Tarifa compra",
		"buy_Rates": "Tarifa compra:",
		"operating": "Operación",
		"edit": "Editar",
		"rate": "Tarifa",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"modifySuc": "Modificado",
		"resetSuc": "Reseteado",
		"unbindSuc": "Desvinculado"
	},
	"auxiliary": {
		"auxiliaryFunction": "Funciones auxiliares",
		"chartSupplement": "Gráfico real",
		"realChart": "Muestra datos reales al activar."
	},
	"strategy": {
		"strategyUpgrade": "Lista estrategias",
		"to": "Volver",
		"UpgFirmware": "Gestión firmware local",
		"strategyIntro": "Resumen actualización local",
		"strategyInfor": "Info estrategia",
		"strategyIntro1": "Solo para actualización Bluetooth. Para WiFi/4G use Gestión Dispositivos",
		"stategyStep2": "Nuevo paquete firmware",
		"stategyStep3": "Subir firmware en gestión local",
		"stategyStep4": "Actualización APP local",
		"stategyStep5": "APP recibe notificación y actualiza localmente",
		"stategyStep6": "Nueva estrategia",
		"stategyStep7": "Crear estrategia con firmware, modo y dispositivos",
		"stategyStep8": "Ver registros",
		"stategyStep9": "Ver estado y resultado",
		"stategyDetail": "Nombre estrategia",
		"stategyDetail1": "Firmware",
		"stategyDetail2": "Tamaño (KB)",
		"stategyDetail3": "Tipo firmware",
		"stategyDetail4": "Baudrate",
		"stategyDetail5": "Modo actualización",
		"stategyDetail6": "Progreso",
		"stategyDetail7": "Estado",
		"stategyDetail8": "Inicio",
		"stategyDetail9": "Fin",
		"upgradeList": "Lista registros",
		"add_strategy": "Lista estrategias",
		"strategy_time": "Tiempo válido",
		"strategy_code": "Código estrategia",
		"strategy_name": "Nombre estrategia",
		"strategy_desc": "Descripción",
		"strategy_firmware": "Firmware",
		"strategy_type": "Tipo firmware",
		"strategy_baudrate": "Baudrate",
		"uprade_type": "Modo",
		"uprade_name": "Forzado",
		"uprade_name1": "Sugerido",
		"uprade_result": "Resultado",
		"uprade_success": "Éxito",
		"uprade_fail": "Fallo",
		"uprade_status": "Estado",
		"uprade_time": "Hora",
		"strategy_number": "Dispositivos",
		"strategy_status": "Estado estrategia",
		"start_time": "Inicio",
		"end_time": "Fin",
		"edit": "Editar",
		"edit_strategy": "Editar estrategia",
		"view": "Ver",
		"view_strategy": "Ver estrategia",
		"cancel": "Cancelar",
		"cancel_strategy": "Cancelar estrategia",
		"force_upgrade": "Forzado",
		"suggested_upgrade": "Sugerido",
		"In_effect": "Activo",
		"expired": "Expirado",
		"Not_started": "No iniciado",
		"Not_upgraded": "No actualizado",
		"Yes_started": "Actualizado",
		"policy_information": "Info estrategia",
		"associated_device": "Dispositivos asociados",
		"completion_strategy": "Completar",
		"upgrade_strategy_list": "Lista estrategias",
		"Next": "Siguiente",
		"TOP": "Anterior",
		"confirm": "Confirmar",
		"go_back": "Volver",
		"strategy_detail": "Detalles",
		"strategy_search": "Código/Nombre",
		"strategy_upgrade_search": "SN/PN",
		"upgrade_remind": "Recordatorio",
		"remind_desc": "Descripción",
		"default_desc": "Descripción por defecto",
		"default_desc1": "El dispositivo necesita actualizarse. No desconecte Bluetooth.",
		"message_name": "Ingrese nombre estrategia",
		"message_desc": "Ingrese descripción",
		"message_firmware": "Seleccione firmware",
		"message_type": "Seleccione tipo",
		"message_baudrate": "Seleccione baudrate",
		"message_timezone": "Seleccione zona horaria",
		"message_time": "Seleccione tiempo válido",
		"message_uprade_type": "Seleccione tipo",
		"delete_firmware": "¿Cancelar esta estrategia?",
		"delete_desc": "Cancelación irreversible",
		"Upgrade_tip": "Seleccione dispositivos",
		"Upgrade_result": "Agregado",
		"start_date": "Fecha inicio",
		"End_date": "Fecha fin",
		"limits":'Tip: Columna A = PN, sin título',
		"mueas":'Estrategia',
		"upNum":'Dispositivos',
		"deletCL":'Eliminar estrategia',
		"deletCL_TEST":'¿Eliminar esta estrategia?',
		"ONE_UP":'Actualización individual',
		"MO_UP":'Actualización en lote',
		"MO_text":'Importados',
		"MO_tex1":'Duplicados',
		"MO_tex3":'No encontrados',
		"MO_tex2":'unidades',
		"MO_tex4":'Firmware en uso, no se puede eliminar',
	
	},
	"cloudsUpgarde": {
		"cloudsFirmware": "Firmware nube",
		"cloudsFirmwareList": "Lista actualización nube"
	},
	"upgradeManagement": {
		"create": "Crear",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"upload_firmware": "Subir firmware",
		"edit_firmware": "Editar firmware",
		"download_firmware": "Descargar",
		"delete_desc": "Eliminación irreversible, estrategias no podrán actualizar",
		"eidt_success": "Editado",
		"delete_success": "Cancelado",
		"delete_success1": "Eliminado",
		"download_success": "Descargando",
		"firmware_name": "Nombre firmware",
		"Firmware_Version": "Versión",
		"please_upgrade": "Seleccione archivo",
		"upgrade_success": "Firmware subido",
		"please_input": "Ingrese",
		"Remarks": "Descripción",
		"Upload": "Subir firmware",
		"download_firmware_prompt": "¿Descargar este firmware?",
		"upgrade_file_format": "Solo .bin/.hex, máx 1MB",
		"upgrade_file_format1": "Solo .bin/.hex",
		"upgrade_file_format2": "Máx 1MB",
		"firmwareName_empty": "Nombre requerido",
		"firmwareVersion_empty": "Versión requerida",
		"download_exception": "Error descarga, reintente",
		"upload_result": "Resultado de la carga",
	},
	"project": {
		"choice": "Filtrar",
		"move": "Mover",
		"manageProject": "Gestión proyectos",
		"project": "Proyecto",
		"defaultProject": "Por defecto",
		"projectName": "Nombre proyecto",
		"projectRemark": "Descripción",
		"projectId": "ID proyecto",
		"createProject": "Nuevo proyecto",
		"createResults": "Resultado",
		"createSuc": "Creado",
		"editProject": "Editar proyecto",
		"editResults": "Resultado edición",
		"editSuc": "Editado",
		"delProject": "Eliminar proyecto",
		"delResults": "Resultado eliminación",
		"delSuc": "Eliminado",
		"upgradeResults": "Resultado actualización",
		"upgradeSuc": "Actualizado",
		"back": "Volver",
		"placeholder": "Buscar por nombre dispositivo/PN/SN",
		"modifySuc": "Éxito",
		"upload": "Subir imagen",
		"limit": "(máx 1M)",
		"moveTo": "Mover a",
		"moveSelect": "Mover selección",
		"deviceSn": "SN dispositivo",
		"tipCard": "Tarjeta",
		"tipList": "Lista",
		"tipSearchSN": "Buscar por dispositivo",
		"tipSearchPN": "Buscar por datalogger",
		"energyCurrent": "Potencia actual",
		"energyDate": "Generación hoy",
		"energyMonth": "Generación mes",
		"energyYear": "Generación año",
		"energyTotal": "Generación total"
	},
	"constant": {
		"renminbi": "Yuan chino(￥)",
		"meiyuan": "Dólar($)",
		"ouyuan": "Euro(€)",
		"aoyuan": "Dólar australiano($A)",
		"yingbang": "Libra(£)",
		"gangbi": "Dólar HK(HK$)",
		"ruidian": "Corona sueca(Kr)",
		"lubi": "Rupia india(₹)",
		"moxige": "Peso mexicano(Mex$)",
		"baxi": "Real(R$)",
		"Pakistani": "Rupia paquistaní(Rs)",
		"Rand": "Rand sudafricano(R)",
		"gmt0": "(GMT +00:00) Dublín, Edimburgo, Lisboa, Londres",
		"gmt_1": "(GMT +01:00) París, Madrid, Copenhague, Roma",
		"gmt_2": "(GMT +02:00) Amán, Damasco, El Cairo, Atenas",
		"gmt_3": "(GMT +03:00) Bagdad, Kuwait, Riad, Nairobi",
		"gmt_4": "(GMT +04:00) Abu Dhabi, Mascate",
		"gmt_5": "(GMT +05:00) Islamabad, Karachi",
		"gmt_55": "(GMT +05:30) Nueva Delhi",
		"gmt_6": "(GMT +06:00) Daca, Astaná",
		"gmt_65": "(GMT +06:30) Myanmar",
		"gmt_7": "(GMT +07:00) Bangkok, Hanói, Yakarta",
		"gmt_8": "(GMT +08:00) Pekín, Chongqing, Hong Kong, Urumqi, Taipei, Kuala Lumpur, Singapur",
		"gmt_9": "(GMT +09:00) Osaka, Tokio, Seúl",
		"gmt_10": "(GMT +10:00) Brisbane, Canberra, Melbourne, Sídney",
		"gmt_11": "(GMT +11:00) Islas Salomón, Vladivostok",
		"gmt_12": "(GMT +12:00) Auckland, Wellington, Fiyi",
		"gmt_13": "(GMT +13:00) Nukualofa",
		"gmt_neg_1": "(GMT -01:00) Azores, Cabo Verde",
		"gmt_neg_2": "(GMT -02:00) Atlántico medio",
		"gmt_neg_3": "(GMT -03:00) Brasilia, Buenos Aires, Groenlandia",
		"gmt_neg_4": "(GMT -04:00) Hora Atlántico, La Paz, Santiago",
		"gmt_neg_5": "(GMT -05:00) Hora del Este (US/Canadá)",
		"gmt_neg_6": "(GMT -06:00) Hora Central (US/Canadá), Ciudad de México",
		"gmt_neg_7": "(GMT -07:00) Hora Montaña (US/Canadá), Arizona",
		"gmt_neg_8": "(GMT -08:00) Hora Pacífico (US/Canadá)",
		"gmt_neg_9": "(GMT -09:00) Alaska",
		"gmt_neg_10": "(GMT -10:00) Hawái",
		"gmt_neg_11": "(GMT -11:00) Islas Samoa",
		"gmt_neg_12": "(GMT -12:00) Línea internacional fecha oeste"
	},
	"basic": {
		"modifySuc": "¡Modificado!",
		"Personal_info": "Modificar info",
		"User_name": "Usuario:",
		"User_name1": "Usuario",
		"Nickname": "Apodo:",
		"Nickname1": "Apodo",
		"editNickname": "Cambiar apodo",
		"Ple_Nickname": "Ingrese apodo",
		"setNickname": "Configurar apodo",
		"Email": "Email:",
		"Email1": "Email",
		"Email2": "Email:",
		"editEmail": "Cambiar email",
		"setEmail1": "Vincular email",
		"Mobile": "Móvil:",
		"Mobile1": "Móvil",
		"editMobile": "Cambiar móvil",
		"setMobile": "Vincular móvil",
		"Avatar": "Avatar",
		"basic": "Info personal",
		"Save": "Guardar",
		"Select_all": "Seleccionar todo",
		"Ple_phone": "Ingrese móvil a vincular",
		"code": "Código:",
		"Ple_code": "Ingrese código",
		"Obtain_code": "Obtener código",
		"Bind_phone": "Vincular móvil",
		"After_bindingPh": "Podrá recuperar contraseña con el móvil",
		"Untie_phone": "Desvincular móvil",
		"Change_phone": "Cambiar móvil",
		"Bind_email": "Vincular email",
		"Ple_email": "Ingrese email a vincular",
		"re_enter": "Reenviar",
		"After_bindingEm": "Podrá recuperar contraseña con el email",
		"Unbind_email": "Desvincular email",
		"Change_email": "Cambiar email",
		"unbind_Ph": "¿Desvincular móvil?",
		"unbinding_Ph": "No podrá recuperar contraseña con este móvil!",
		"unbind_Em": "¿Desvincular email?",
		"unbinding_Em": "No podrá recuperar contraseña con este email!",
		"mobile_code": "Código enviado a su móvil",
		"email_code": "Código enviado a su email",
		"suc_ph": "Móvil vinculado",
		"suc_em": "Email vinculado",
		"code_frequently": "Envío frecuente, espere",
		"personalCenter": "Config cuenta",
		"basicInfo": "Info básica",
		"accountSecurity": "Seguridad cuenta",
		"backTo": "Volver",
		"uploadAvatar": "Cambiar avatar",
		"bindPhone": "Vincular móvil",
		"bindEmail": "Vincular email",
		"changePwdTip": "Contraseña segura: 6-32 caracteres. Cámbiela periódicamente.",
		"bindPhoneTipBefore": "Móvil vinculado:",
		"bindEmailTipBefore": "Email vinculado:",
		"bindPhoneTip": "Configure un móvil para login y recuperación.",
		"bindEmailTip": "Configure un email para login y recuperación.",
		"bindPhoneTipAfter": ", puede usarlo para login y recuperación.",
		"changeBtn": "Cambiar",
		"changePwd": "Cambiar contraseña",
		"changePwdSuc": "Contraseña cambiada",
		"finished": "Finalizar",
		"retry": "Reintentar",
		"changeRes": "Resultado cambio",
		"bindRes": "Resultado binding",
		"noHanzi": "Sin caracteres chinos",
		"Nickname_length_tip": "Apodo: 2-32 caracteres"
	},
	"password": {
		"User_name": "Usuario:",
		"Password": "Cambiar contraseña",
		"Current_password": "Actual:",
		"New_password": "Nueva:",
		"Config_newpassword": "Confirmar:",
		"PLCurrent_password": "Ingrese actual",
		"PLNew_password": "Ingrese nueva",
		"PLConfig_newpassword": "Confirme nueva",
		"editPwdSuc": "¡Contraseña cambiada!",
		"loginAgain": "Contraseña cambiada, inicie sesión de nuevo",
		"Save": "Guardar"
	},
	"settingalarm": {
		"chosesstation": "Seleccione planta",
		"addEmails": "Agregar email",
		"delete": "Email eliminado",
		"deletes": "Eliminar",
		"Email_List": "Lista emails",
		"Add_Mailbox": "Nuevo envío email",
		"cancel": "Cancelar",
		"Add": "Agregar",
		"Email_Setting": "Config envío email",
		"Alarm_Type": "Tipo alerta:",
		"Warning": "Advertencia",
		"Error": "Error",
		"Fault": "Fallo",
		"Receiving_Report": "Gestión reportes",
		"Daily_Report": "Diario",
		"Monthly_Report": "Mensual",
		"Yearly_Report": "Anual",
		"Receiving_Plant": "Plantas:",
		"E_Mail": "Email:",
		"Email": "Email",
		"Plant": "Planta asociada",
		"Operation": "Operación",
		"Alarm_Typetabel": "Tipo alerta",
		"Yes": "Sí",
		"No": "No",
		"Delete": "Eliminar",
		"suredelete": "¿Eliminar este envío?",
		"Delete_Mailbox": "Eliminar email",
		"Add_suc": "¡Email agregado!",
		"create": "Crear",
		"list": "Nº",
		"edit": "Editar"
	},
	"recharge": {
		"Datalogger_List": "Lista dataloggers",
		"Datalogger_PN": "PN",
		"DataloggerPN": "PN:",
		"DataloggerName": "Alias",
		"CCID": "Nº tarjeta SIM",
		"CCID_time": "Vencimiento",
		"Plant": "Nombre planta",
		"Connecting_Devices": "Dispositivos",
		"Status": "Estado tarjeta",
		"Signal": "Señal",
		"Activation_Time": "Activación",
		"Dead_Time": "Vencimiento",
		"Operation": "Operación",
		"Recharge_record": "Historial recargas",
		"Time": "Hora recarga",
		"Order_Number": "Nº pedido",
		"Rcharge_Month": "Meses",
		"Recharge_money": "Monto",
		"rechargeStatus": "Estado recarga",
		"Unpaid": "No pagado",
		"Paid": "Pagado",
		"Recharge_successful": "Recargado",
		"Recharge_fail": "Fallo recarga",
		"Recharging": "Cargando",
		"normal": "Normal",
		"warning": "Advertencia",
		"Overdue": "Vencido",
		"expired": "Expirado",
		"unknown": "Desconocido",
		"Recharge_status": "Estado",
		"ccid": "Nº tarjeta SIM",
		"Traffic_status": "Estado tráfico",
		"Recharge": "Recargar",
		"Recharge1": "Recargar datos",
		"load": "Dispositivos",
		"pn": "PN",
		"serial_number": "Nº",
		"rechargeErr": "Seleccione dataloggers con misma carga",
		"rechargeDevice": "Dispositivo:",
		"rechargePackage": "Paquete:",
		"rechargeChannel": "Método:",
		"rechargePrice": "Monto:",
		"rechargeDiscount": "Descuento:",
		"scan": "Escanear para pagar",
		"openWx": "Abra WeChat",
		"scanComplete": "Escanee para completar",
		"previous": "Volver",
		"rechargeSuc": "Pagado",
		"rechargeSucInfo": "Pagado. Datos en 24h.",
		"orderno": "Nº pedido",
		"Recharged": "Recargado",
		"Recharge_List": "Lista recargas",
		"not_for_the_time_being": "Más tarde",
		"Recharge_now": "Recargar ahora",
		"early_warning": "Alerta vencimiento tarjeta",
		"Content_warning": "Su tarjeta está por vencer. ¡Recargue para evitar pérdida de servicio!",
		"Recharge_reminder": "Recordatorio recarga",
		"Recharge_Selected": "Recargar",
		"Search": "Buscar",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"rechMoney": "Pagar",
		"rechDiscount": "Descuento",
		"rechScan": "Abra WeChat para escanear y pagar",
		"rechTip": "Tip: 1) Mismo tipo de tarjeta (ej: 4G nacional), misma carga de dispositivos y misma plataforma; 2) Tarjetas vencidas o recargas del 25 al 5 pueden tardar 1-14 días",
		"Hint_language": "Tiene dispositivos 2G. Se recomienda actualizar a 4G.",
		"Tips": "Tip",
		"Confirm_recharge": "Confirmar recarga",
		"Cancel_recharge": "Cancelar recarga",
		"Hint_language1": "Problemas? Llame 0755-89993588",
		'recharge_type': "Tipo",
		'Service_Area': "Área servicio",
		'Package_type': "Tipo paquete",
		'domestic': 'Nacional',
		'abroad': 'Internacional',
		'Recharge_tip': 'Recordatorio',
		'Recharge_tip1': 'Solo tarjetas del mismo tipo',
		'Recharge_tip2': 'Ej: misma carga 1, mismo tipo 4G, misma área',
		'Recharge_tip3': 'Recomendado para usuarios WeChat',
		'Recharge_tip4': 'Recomendado para usuarios PayPal',
		'Recharge_tip5': 'Pago WeChat',
		'Recharge_tip6': 'Tarjetas no soportadas, contacte admin',
		'area_domestic': 'China continental',
		'area_abroad': 'Internacional',
				'remedy_title': 'Remedio de orden de recarga',
				'upload_tip': 'Recordatorio amistoso: El formato del archivo de carga es .txt'
	},
	"customize": {
		"switchSkin": "Cambiar tema",
		"classic": "Rosa",
		"purple": "Púrpura",
		"blue": "Azul clásico",
		"orange": "Naranja",
		"green": "Verde"
	},
	"firmware": {
		"Firmware_limit_format": "Solo se pueden cargar archivos en formato \".bin\", \".hex\" y \".s19\"",
		"Firmware_upload_fail": "Error al cargar, ¡por favor intente de nuevo!",
		"Firmware_upload_failTip": "Error al cargar",
		"Firmware_limit1": "Se puede cargar un máximo de",
		"Firmware_limit2": "",
		"Firmware_limit3": "firmwares",
		"Firmware_limitM": "El tamaño de un solo firmware no puede exceder",
		"Firmware_Name": "Nombre firmware",
		"Firmware_desrc": "Descripción",
		"Size": "Tamaño(KB)",
		"Upload_Time": "Subido",
		"Operation": "Operación",
		"Firmware_List": "Gestión firmware",
		"Firmware_Lists": "Lista firmware",
		"Add_Firmware": "Agregar firmware",
		"deleteFirmware": "Eliminar",
		"Firmware_Version": "Versión",
		"editFirmware": "Editar",
		"downloadFirmware": "Descargar",
		"tips": "Tip",
		"noRecord": "Sin registros",
		"delete_firmware": "¿Eliminar este firmware?",
		"del_firmware": "Eliminar firmware",
		"firmware_upgrade": "Actualizar firmware",
		"uploadTips": "Suba archivo firmware",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"Upload_firmware": "Subir firmware",
		"Firmware_description": "Descripción:",
		"enter_content": "Ingrese contenido",
		"Select_file": "Seleccionar archivo",
		"limit": "Solo se pueden subir archivos .bin y .hex, máx 8M",
		"limit0": "Solo .bin/.hex/.s19, máx 8M",
		"limit1": "Solo xlsx",
		"limit2": "Tip: Columna A = PN, B = Alias, sin título",
		"limit3": "Agregado",
		"error1": "Solo .bin/.hex/.s19",
        "error2": " Please press LFU button",
		"deleteSuc": "Eliminado",
		"UploadTitle": "Suba archivo en lote",
		"Upload": "Subir firmware",
		"Upload1": "Subir archivo",
		"upgrade_quit1": "¡Error actualización, saliendo!",
		"upgrade_quit2": "Fallo actualización, reintente!",
		"upgrade_quit3": "Actualizado",
		"upgrade_quit4": "Actualización cancelada",
		"upgrade_quit5": "No en actualización",
		"upgrade_quit6": "Cancelar actualización",
		"upgrade_quit7": "Fallo actualización",
		"upgrade_quit8": "Error actualización",
		"upgrading": "Actualizando",
		"upgrading1": "Conectando, espere",
		"updateCompleted": "Actualización completada",
		"CancelUpgradeSuc": "Actualización cancelada",
		"FailedCancelUpgrade": "Fallo al cancelar",
		"CancelUpgradeSuc11": "Cancelada. Espere a que el datalogger se conecte.",
		"upgrade_wait": "Preparando, espere 1-2 min",
		"upgrade_wait1": "Preparado. Espere conexión del datalogger.",
		"colOffline": "Datalogger offline",
		"colUpgrading": "Ya actualizando",
		"UpgradeStarting": "Actualización iniciada, por favor espere...",
		"upgradeSq_fail": "La actualización del datalogger falló, ¡inténtelo de nuevo más tarde!",
	},
	"browse": {
		"usr": "Subcuenta",
		"email": "Email",
		"mobile": "Móvil",
		"gts": "Fecha registro",
		"desc": "Nota",
		"enableStatus": "Estado",
		"Enable": "Activar",
		"Disable": "Desactivar",
		"addBrowse": "Agregar subcuenta",
		"pleaseUsr": "Ingrese subcuenta",
		"accountInfo": "Info cuenta",
		"username": "Usuario",
		"password": "Contraseña",
		"newPassword": "Nueva contraseña",
		"confirmPassword": "Confirmar contraseña",
		"usrInfo": "Info usuario",
		"device": "Seleccionar proyecto",
		"pleaseDevice": "Seleccionar proyecto",
		"pleaseDevice_title": "Seleccione proyecto",
		"pleaseStatus": "Seleccionar estado",
		"addSuccess": "Subcuenta agregada",
		"editSuccess": "Subcuenta editada",
		"editBrowse": "Editar subcuenta",
		"deleteSuccess": "Eliminado",
		"deleteBrowse": "Eliminar",
		"delete_browse": "¿Eliminar subcuenta?",
		"please_browsepwd": "Verifique contraseñas"
	},
	"retrieve": {
		"Retrieve_password": "Recuperar contraseña",
		"Retrieve_passwordPhone": "Recuperar por móvil",
		"Retrieve_passwordEmail": "Recuperar por email",
		"passwordEmail": "Email no vinculado",
		"passwordEmail1": "Email no coincide",
		"passwordPhone": "Móvil no vinculado",
		"passwordPhone1": "Móvil no coincide",
		"login": "Login",
		"signup": "Registrar",
		"Enter_account": "Ingresar cuenta",
		"Verify_identidy": "Verificar identidad",
		"reset_Password": "Resetear contraseña",
		"finish": "Finalizar",
		"account_password": "Ingrese cuenta para recuperar",
		"username": "Usuario",
		"Verification_code": "Código",
		"phone_number": "Móvil",
		"new_password": "Nueva contraseña",
		"Con_password": "Confirmar contraseña",
		"enter_name": "Ingrese usuario",
		"enter_code": "Ingrese código",
		"Change_one": "Cambiar",
		"confirm": "Confirmar",
		"bound_mobile": "Ingrese móvil vinculado",
		"Email_verification": "Verificación email",
		"Obtain_code": "Obtener código",
		"code_1minute": "Código enviado a su móvil, válido 1 min.",
		"Email": "Email",
		"bound_email": "Ingrese email vinculado",
		"Phone_verification": "Verificación móvil",
		"code_5minutes": "Código enviado a su email, válido 5 min.",
		"New_password": "Nueva contraseña",
		"Confirm_password": "Confirmar contraseña",
		"Reset_successfully": "Contraseña reseteada, recuérdela",
		"re-register": "Login",
		"Incorrect_code": "Código incorrecto",
		"email_first": "Ingrese email primero",
		"mobile_first": "Ingrese móvil primero",
		"Reset_passwordSuc": "Contraseña reseteada",
		"Get_codeSucc": "Código obtenido",
		"Getting_progress": "Obteniendo, espere!",
		"Newloginpassword": "Nueva contraseña",
		"Confirmloginpassword": "Confirmar contraseña",
		"step1": "Paso 1",
		"step2": "Paso 2",
		"step3": "Paso 3",
		"step4": "Paso 4"
	},
	"errCode": {
		"0": "Normal, sin error",
		"1": "Fallo",
		"2": "Timeout, sistema ocupado, reintente",
		"3": "Error sistema, contacte admin",
		"4": "Caracteres especiales no permitidos",
		"5": "Error salt",
		"6": "Formato parámetro incorrecto",
		"7": "Parámetro requerido faltante",
		"8": "Plataforma rechazada",
		"9": "Operación no soportada",
		"10": "No autenticado, login requerido",
		"11": "Sin permisos",
		"12": "Sin registros",
		"13": "Límite excedido",
		"14": "Operación duplicada",
		"15": "Key fabricante no encontrado",
		"16": "Contraseña incorrecta",
		"17": "Formato contraseña incorrecto",
		"18": "Móvil ya vinculado",
		"19": "Formato móvil incorrecto",
		"20": "Formato email incorrecto",
		"21": "Formato usuario incorrecto",
		"22": "Formato empresa incorrecto",
		"23": "Código fabricante inválido",
		"24": "Usuario ya existe",
		"25": "Cuenta deshabilitada",
		"26": "Email ya vinculado",
		"27": "Cuenta cancelada",
		"256": "Sin datos",
		"257": "Sin datalogger",
		"258": "Sin dispositivo",
		"259": "PN inválido, verifique",
		"260": "Sin planta",
		"261": "Usuario no encontrado",
		"262": "Dispositivo offline",
		"263": "Datalogger offline",
		"264": "Sin alertas dispositivo",
		"265": "Sin monitor ambiental",
		"271": "Sin modificaciones",
		"272": "Binding duplicado",
		"273": "No soporta dataloggers de otros fabricantes",
		"276": "No soporta mover propietarios con dataloggers de otros fabricantes",
		"288": "Sin cámara",
		"352": "Sin firmware",
		"353": "Sin protocolo",
		"368": "Sin rol",
		"369": "Sin grupo usuarios",
		"370": "Sin grupo plantas",
		"371": "Sin paquetes recarga GPRS",
		"372": "Sin pedidos recarga GPRS",
		"384": "Código verificación incorrecto",
		"385": "Sin device_token",
		"386": "Sin info config dispositivo",
		"387": "Sin tipo datalogger",
		"512": "Código SMS no coincide",
		"513": "Código SMS expirado",
		"514": "Móvil/Email no vinculado",
		"515": "Móvil/Email no coincide",
		"516": "Nombre ya existe",
		"517": "Usuario o planta aún tiene dataloggers",
		"518": "Usuario aún tiene subusuarios",
		"519": "Usuario ya existe",
		"520": "PN duplicado",
		"521": "Datalogger no pertenece al usuario",
		"522": "Datalogger ya existe",
		"523": "No es cuenta visualizador",
		"525": "Código ya enviado, espere",
		"528": "Rol vinculado a usuarios, no se puede eliminar",
		"768": "Sin campos opcionales en protocolo",
		"772": "Datalogger ya vinculado",
		"1024": "Solo propietarios",
		"1025": "Solo administradores",
		"1026": "Solo fabricantes",
		"1027": "Usuario superior debe ser admin o fabricante",
		"1028": "Método recarga no soportado",
		"1029": "Nº datalogger duplicado",
		"1030": "Tarjeta GPRS inválida",
		"1031": "Usuario no creado por este admin",
		"1041": "Key expirado o no encontrado",
		"1042": "CCID inválido",
		"1792": "Dataloggers deben ser del mismo admin"
	},
	"controlDeviceErrCode": {
		"1": "Operación fallida, verifique dispositivo",
		"2": "Timeout, reintente",
		"3": "Error sistema, contacte admin",
		"6": "Error formato, contacte admin",
		"8": "Rechazado, contacte admin",
		"9": "Operación no soportada, contacte admin",
		"11": "Sin permisos, contacte admin",
		"263": "Datalogger offline, espere conexión"
	},
	"control":{
		setting: "Enviar",
		TouSetting: "Modo trabajo sistema",
		touCharge: "Prioridad carga",
		touPersonal: "Autoconsumo",
		touComplete: "Venta total",
		touClipping: "Gestión de picos y valles",
		touOffgrid: "Aplicación off-grid",
		confirmModeSwitch: "¿Cambiar modo?",
		modeSwitch: "Cambiar modo",
		startTime: "Hora inicio",
		endTime: "Hora fin",
		paramValue: "Seleccione valor",
		Monday: "Lunes",
		Tuesday: "Martes",
		Wednesday: "Miércoles",
		Thursday: "Jueves",
		Friday: "Viernes",
		Saturday: "Sábado",
		Sunday: "Domingo",
		syncSetDay: "Sincronizar a todos los días",
		time: "Período 1",
		time1: "Período 2",
		time2: "Período 3",
		time3: "Período 4",
		time4: "Período 5",
		time5: "Período 6",
		setFail: "Fallo envío",
		readFail: "Fallo lectura",
		charge: "Carga",
		discharge: "Descarga",
		reading: "Lectura exitosa",
		reading_loading: "Leyendo...",
		pvMode: "Modo exportación",
		"screenshot": "Captura",
	},
	"CollectorCountByOMSOrder": {
		"1": "Operación fallida",
		"7": "Parámetro requerido faltante",
		"8": "Rechazado, contacte admin",
		"12": "Sin dataloggers válidos en el pedido",
		"23": "Código fabricante inválido",
		"259": "Datalogger inválido en el pedido",
		"261": "Distribuidor no encontrado",
		"772": "Datalogger ya vinculado en el pedido"
	},
	"message": {
		"uname_is_required": "Usuario requerido",
		"id_is_required": "Grupo requerido",
		"pwd_is_required": "Contraseña requerida",
		"confpwd_is_required": "Confirmar contraseña requerida",
		"invitation_is_required": "Código demo requerido",
		"pwdAgain": "Ingrese contraseña de nuevo",
		"pwdSame": "Contraseñas no pueden ser iguales",
		"oldPass_wrong": "Contraseña actual incorrecta",
		"pwdNotsame": "Contraseñas no coinciden",
		"email_is_required": "Email requerido",
		"email_info": "Email válido, máx 64 caracteres",
		"mobile_is_required": "Móvil requerido",
		"pn_is_required": "PN requerido",
		"PN_info": "PN 14 o 18 caracteres, primera letra mayúscula",
		"nodata": "Sin datos",
		"length2_64": "2-64 caracteres",
		"length2_32": "2-32 caracteres",
		"length6_20": "6-20 letras, números, guión bajo",
		"length6_32": "6-32 caracteres",
		"delete_plant": "Eliminar planta",
		"modify_plant": "Modificar planta",
		"Exporting_the_report": "Exportar reporte",
		"cancel": "Cancelar",
		"search": "Buscar",
		"Logging_off": "Cuenta en proceso de cancelación",
		"country_is_required": "Seleccione país",
	},
	"report": {
		"Export_report": "Exportar reporte",
		"Subscribe_report": "Suscribir reporte",
		"all_reports": "Exportar todo",
		"Report_type": "Tipo:",
		"Daily_report": "Diario",
		"Monthly_report": "Mensual",
		"Yearly_Report": "Anual",
		"Total_report": "Total",
		"customize": "Personalizado",
		"Report_date": "Fecha:",
		"Report_date1": "Nota: máx 31 días",
		"select_date": "Seleccione fecha",
		"to": "a",
		"start_date": "Inicio",
		"End_date": "Fin",
		"cancel": "Cancelar",
		"Export": "Exportar",
		"download": "Descargando, espere",
		"Batch_export": "Exportar en lote",
		"current": "Ahora",
		"no_deAlarm": "Sin alertas último mes",
		"Export_alarm": "Exportar alertas"
	},
	"actionLog": {
		"index": "Nº",
		"date": "Fecha",
		"user": "Usuario",
		"acitonDesc": "Descripción",
		"startTime": "Inicio",
		"endTime": "Fin",
		'userNote': 'Ingrese usuario',
		"userName": "Usuario",
		'uidNote': 'Ingrese UID',
		'PNNote': 'Ingrese PN',
		'actionNote': 'Ingrese action',
		'All': 'Todos'
	},
	"factory": {
		"name": "Nombre fabricante",
		"code": "Código fabricante",
		"time": "Generado",
		"append": "Nuevo código",
		"amend": "Modificar código",
		"delete": "Eliminar código",
		"delete_warn": "¿Eliminar código?",
		"input_tip": "Código 2-3 dígitos o letras",
		"error_tip": "Error entrada",
		"right_tip": "Correcto",
		"editSuc": "Modificado",
		"prompt_codeTip": "Código requerido",
		"prompt_nameTip": "Nombre requerido",
		"ID": "ID fabricante",
		"acount": "Cuenta fabricante",
		"usrName": "Nombre cuenta",
		"acountType": "Tipo cuenta",
		"isEnabled": "Activado",
		"chooseIsEnabled": "Seleccione estado",
		"enabled": "Activado",
		"disabled": "Desactivado",
		"visibleDevcode": "Códigos visibles",
		"pwd": "Contraseña",
		"accountInfo": "Info cuenta",
		"comfirmPwd": "Confirmar",
		"factoryInfo": "Info fabricante",
		"devcode": "Código dispositivo",
		"devcode_is_requeired": "Código requerido",
		"confirmDelete": "¿Eliminar",
		"confirmDelete1": "fabricante?",
		"ecoin": "E-coin"
	},
	"keyList": {
		"companyName": "Empresa",
		"version_number": "Versión",
		"client": "Cliente",
		"domainName": "Dominio",
		"contact_information": "Contacto",
		"key": "Key",
		"describe": "Descripción",
		"unseal": "Activo",
		"platform": "Plataforma",
		"companyNameTips": "Empresa requerida",
		"domainNameTips": "Dominio requerido",
		"version_numberTips": "Versión requerida",
		"contact_informationTips": "Contacto requerido",
		"clientTips": "Plataforma requerida",
		"keyTips": "Key requerido",
		"keyTips2": "Key de 16 bytes",
		"describeTips": "Descripción requerida",
		"unsealTips": "Estado requerido",
	},
	"protocol": {
		"pn": "PN",
		"postal_address": "Dirección",
		"Protocol_encoding": "Código protocolo",
		"date": "Fecha",
		"Please_date": "Seleccione fecha",
		"Protocol_instructions": "Instrucciones protocolo",
		"Query_Results": "Resultados",
		"query": "Consultar",
		"CRC_verification": "Verificación CRC",
		"Length_verification": "Verificación longitud",
		"Data_index": "Índice datos",
		"raw_data": "Datos raw",
		"verification_results": "Resultado CRC",
		"agreement": "Coincide",
		"atypism": "No coincide",
		"verification_result": "Resultado longitud",
		"Analysis_results": "Resultados análisis",
		"Please_results": "Obtenga resultados primero",
	},
	"rawData": {
		"pn": "PN",
		"Equipment_number": "SN",
		"Equipment_coding": "Código",
		"Device_address": "Dirección",
		"date": "Fecha",
		"Please_date": "Seleccione fecha",
		"encrypted": "Encriptado",
		"Please_type": "Seleccione tipo",
		"yes": "Sí",
		"no": "No",
		"raw_data": "Datos raw",
		"analysis": "Analizar",
	},
	"collectionFrequencyUP": {
		"collect_fast": "Acelerar flujo energía",
		"collect_fast2": "Aceleración del flujo energético",
		"collect_fast_fail": "Aceleración fallida, inténtelo de nuevo",
		"collect_fasting": "Acelerando",
		"collect_fast_starting": "Iniciando aceleración",
		"collect_fast1": "Acelerar datos",
		"collect_fast1ing": "Acelerando datos",
		"paySecCon": "Confirmar pago",
		"energyFetchPic": "¿Confirmar recarga? Ver imagen de parámetros",
		"historyFetchPic": "¿Confirmar recarga? Ver imagen de datos",
		"reRechargeTip1": "El dispositivo actual ya ha comprado el servicio de aceleración de flujo de energía. Continuar con la compra generará cargos nuevamente. ¿Desea continuar?",
		"reRechargeTip": "El dispositivo actual ya ha comprado el servicio de aceleración de detalles de datos. Continuar con la compra generará cargos nuevamente. ¿Desea continuar?",
		"continueRecharge": "Continuar recarga",
		"collect_fasting_title": "Parámetros no almacenados",
		"collect_Order_Record": "Historial aceleración",
		"collect_recharge": "Recarga aceleración (datos)",
		"collect_recharge1": "Recarga aceleración (flujo)",
		"Package": "Paquete",
		"every_interval": "Intervalo actual:",
		"gather": "Recolectar",
		"Once": "vez",
		"Payment_method": "Método pago",
		"Online_payment": "Pago online",
		"Recharge_now": "Recargar",
		"have_read": "He leído",
		"Collection_terms": "Términos",
		"Purchase_Terms": "Términos compra",
		"Purchase_Terms1": "Período de validez de la aceleración de recopilación",
		"Purchase_Terms2": "El tiempo de vencimiento del servicio de aceleración de recopilación se calculará automáticamente según la duración del paquete que haya adquirido. El tiempo de vencimiento específico está sujeto a lo que se muestra en la página",
		"Purchase_Terms3": "¿Personalizar parámetros?",
		"Purchase_Terms4": "Próximamente en nueva versión",
		"Purchase_Terms5": "Precio paquete",
		"Purchase_Terms6": "Calculado según parámetros, frecuencia y carga",
		"Purchase_Terms7": "¿Otras dudas?",
		"Purchase_Terms8": "Contacte soporte",
		"Collect_terms": "Términos aceleración",
		"Collect_terms1": "Términos servicio aceleración",
		"Collect_terms2": "1. Alcance del paquete",
		"Collect_terms3": "Aplica a parámetros del protocolo del datalogger",
		"Collect_terms4": "2. Sin cambio protocolo/dispositivo",
		"Collect_terms5": "Cambios no incluidos",
		"Collect_terms6": "3. Cancelación",
		"Collect_terms7": "No reembolsable ni modificable",
		"Collect_terms8": "4. Precio",
		"Collect_terms9": "Según parámetros, frecuencia y carga",
		"Collect_terms10": "5. Consumo datos",
		"Collect_terms11": "Aceleración aumenta consumo",
		"Scan_payment": "Escanear para pagar",
		"Recharge_result": "Resultado",
		"Recharge_successful": "Recargado",
		"Recharge_successful_next": "¡Recargado! Frecuencia actualizada.",
		"Order_No": "Nº pedido",
		"Recharge_time": "Hora",
		"Recharge_amount": "Monto",
		"view_order": "Ver pedido",
		"Recharge_failed": "Fallo recarga",
		"Recharge_failed_next": "Fallo. Reintente pago.",
		"PN_order": "PN/Pedido",
		"View_Details": "Ver detalles",
		"Type": "Tipo",
		"Real_parameters": "Parámetros tiempo real",
		"History_Data": "Datos históricos",
		"acquisition_frequency": "Frecuencia",
		"device_Info": "Info dispositivo",
		"noRecharg": "Datalogger no soporta recarga",
		"noRecharg_min": "¡Ya está al máximo!",
		"noRecharg_wifi": "Solo Wi-Fi soportado",
		"paypalTip": "Monto final según PayPal",
		"upPrice": "Completar precio",
	},
	alarmNew:{
		'fileName':'Archivo',
		'fileSize':'Tamaño',
		'fileStatus':'Estado',
		'progress':'Progreso',
		'can':'Descargable',
		'no':'Exportando',
		'history':'Historial',
		'brand3-list':'Lista ESS integrado'
	},
	shuoriExport:{
		"exportRecords": "Exportar registros",
		"export": "Exportar",
		"exportTask": "Tarea creada, descargue más tarde",
		"noDownload": "Archivo inválido, reintente",
		'data': 'Fecha',
	},
	colUnBindRecord: {
		'UnBindRecord': 'Registros desvinculación',
		'unStatus': 'Estado',
		'unScene': 'Escenario',
		'oldUser': 'Usuario anterior',
		'newUser': 'Nuevo usuario',
		'unCount': 'Veces',
		'pnBarCode': 'Código barras',
		'devicePicture': 'Foto',
		'ip': 'IP',
		'unTime': 'Hora',
	},
		rosRecharge: {
		'electronicInvoicing': 'Facturación electrónica',
		'issueEInvoice': 'Emitir factura electrónica',
		'invoiceHistory': 'Historial de facturas',
		'rechargeDuration': 'Duración de recarga',
		'year': 'Año',
		'month': 'Mes',
		'day': 'Día',
		'days': 'Días',
		'pendingPayment': 'Pago pendiente',
		'paymentSuccess': 'Pago exitoso',
		'paymentFailed': 'Pago fallido',
		'orderClosed': 'Pedido cerrado',
		'serviceTerminated': 'Servicio terminado',
		'unpaid': 'No pagado',
		'paying': 'Pagando',
		'paid': 'Pagado',
		'refunded': 'Reembolsado',
		'cancelled': 'Cancelado',
		'rechargeSuccess': 'Recarga exitosa',
		'rechargeFailed': 'Recarga fallida',
		'pleaseSelectDate': 'Por favor seleccione una fecha',
		'orderNo': 'Número de pedido',
		'batchInvoicing': 'Facturación por lotes',
		'rechargeType': 'Tipo de recarga',
		'trafficRecharge': 'Recarga de tráfico',
		'collectRecharge': 'Recarga de recolección',
		'rechargeStatus': 'Estado de recarga',
		'invoice': 'Factura',
		'invoiceStatus': 'Estado de la factura',
		'invoiceTime': 'Hora de facturación',
		'viewDetail': 'Ver detalles',
		'invoicing': 'Facturando',
		'invoiceSuccess': 'Factura emitida',
		'invoiceFailed': 'Error al emitir la factura',
		'issueElectronicInvoice': 'Emitir factura electrónica',
		'invoiceType': 'Tipo de factura',
		'generalInvoice': 'Factura ordinaria',
		'specialInvoice': 'Factura especial',
		'headerType': 'Tipo de encabezado',
		'companyHeader': 'Encabezado de empresa',
		'personalHeader': 'Encabezado personal/no empresarial',
		'pleaseInputCompanyHeader': 'Por favor ingrese el encabezado de la empresa',
		'taxNumber': 'Número de impuesto de la empresa',
		'pleaseInputTaxNumber': 'Por favor ingrese el número de identificación del contribuyente',
		'headerName': 'Nombre del encabezado',
		'suggestPersonalName': 'Se sugiere ingresar nombre personal/nombre de la tienda',
		'invoiceContent': 'Contenido de la factura',
		'internetCommService': 'Servicio de comunicación por Internet',
		'invoiceAmount': 'Importe de la factura',
		'yuan': 'Yuan',
		'moreInfo': 'Más información',
		'remarkAddressEtc': 'Notas, dirección, etc.',
		'companyAddress': 'Dirección de la empresa',
		'pleaseInputCompanyAddress': 'Por favor ingrese la dirección de la empresa',
		'companyPhone': 'Teléfono de la empresa',
		'pleaseInputCompanyPhone': 'Por favor ingrese el teléfono de la empresa',
		'openingBank': 'Banco de apertura de cuenta',
		'pleaseInputOpeningBank': 'Por favor ingrese el banco de apertura de cuenta',
		'bankAccount': 'Número de cuenta bancaria',
		'pleaseInputBankAccount': 'Por favor ingrese el número de cuenta bancaria',
		'remark': 'Nota',
		'pleaseInputRemark': 'Por favor ingrese una nota',
		'email': 'Correo electrónico',
		'pleaseInputEmail': 'Por favor ingrese la dirección de correo electrónico',
		'cancel': 'Cancelar',
		'submit': 'Enviar',
		'invoiceResult': 'Resultado de facturación',
		'invoiceSubmitted': 'Solicitud de facturación enviada',
		'invoiceExpectedTip': 'La factura se emitirá en 48 horas, por favor verifique',
		'viewInvoiceStatus': 'Ver estado de facturación',
		'pleaseInputHeaderName': 'Por favor ingrese el nombre del encabezado',
		'pleaseInputValidEmail': 'Por favor ingrese una dirección de correo electrónico válida',
		'invoiceApplyFailed': 'Error en la solicitud de facturación',
		'viewInvoice': 'Ver factura',
		'downloadPdf': 'Descargar archivo PDF',
		'manualService': 'Atención al cliente',
		'invoiceSentToEmail': 'La información de la factura ha sido enviada al correo electrónico, por favor verifique',
		'pleaseWaitInvoicing': 'Por favor espere a que se complete la facturación',
		'pleaseContactManual': 'Por favor contacte al servicio de atención al cliente para la facturación',
		'noPdfAvailable': 'No hay archivos PDF disponibles para descargar',
		'serviceUnavailable': 'Función de atención al cliente no disponible',

	}
}
export default es;